import React, { Suspense, lazy } from 'react';
import Loader from '~components/main-loader';

const MapPage = lazy(() => import('./index'))

function MapPageLazy(props) {
    return (
        <Suspense fallback={<Loader/>}>
            <MapPage {...props} />
        </Suspense>
    );
}

export default MapPageLazy;
export { MapPageLazy };



// WEBPACK FOOTER //
// ./src/routes/main/covid-page/lazy.js